import * as React from "react";

import { SkipContent } from "@ingka/skip-content";

const Container: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<main className="page-container" id="main">
			<div className="page-container__inner">
				<div className="page-container__main">
					<SkipContent label="Skip to footer" aria-label="Skip to footer" targetId="flagga-footer">
						{children}
					</SkipContent>
				</div>
			</div>
		</main>
	);
};

export default Container;
